// @flow
import * as React from "react";
import {reisy, use} from "reisy";
import Navigation from "../navigation/index.js";
import Heading from '../components/heading';

export const styles = reisy`
@namespace ContentError;

JackInTheBox: $Settings.JackInTheBox;

Error {
	@extends Helpers.Fullscreen;
}
Contain {
	@extends Helpers.Contain;
}

Content {
	max-width: 300px;
	margin: 4em auto 3em;
	color: #c00;
	text-align: center;

	p {
		font-family: $Fonts.aside;
	}
}

Title {
	font-family: $Fonts.title;
	font-size: 3rem;
}
`;

type Props = {
	type: number;
	message: string;
};

const ContentError = ({message, type}: Props) => (
	<div {...use(styles.Error, styles.JackInTheBox && styles.Contain)}>
		<Navigation />
		<div {...use(styles.Content)}>
			<Heading lvl={1} {...use(styles.Title)}>{type}</Heading>
			<p>{message}</p>
		</div>
	</div>
);
export default ContentError;



// WEBPACK FOOTER //
// ./lib/screens/error.js